import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";
import Loader from "../Common/Loader";
import {
  createDefaultDoseAction,
  updateDefaultDoseAction,
} from "../../../store/actions/DefaultDoseAction";

const AddDefaultDose = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { item } = location.state || {};
  const isEditMode = !!item;

  const [text, setText] = useState("");
  const [status, setStatus] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ];
  useEffect(() => {
    if (isEditMode && item) {
      setText(item.dose_text || "");
      setStatus(item.dose_status === "Active" ? 1 : 0);
    }
  }, [isEditMode, item]);

  const validateForm = () => {
    const err = {};
    if (!text.trim()) err.text = "Default dose is required";
    if (status === "" || status === null)
      err.status = "Status is required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const { [field]: _removed, ...rest } = prev;
      return rest;
    });
  };

  const handleFieldChange = (field, value) => {
    if (field === "text") {
      setText(value);
    } else if (field === "status") {
      setStatus(value);
    }
    clearFieldError(field);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    const payload = {
      dose_text: text,
      dose_status: status === 1 ? "Active" : "Inactive",
    };

    try {
      if (isEditMode) {
        await dispatch(updateDefaultDoseAction(payload, item.id));
      } else {
        await dispatch(createDefaultDoseAction(payload));
      }

      navigate("/default-dose");
    } catch (error) {
      console.error("Save failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-xl-12">

        {/* Back Button */}
        <div className="d-flex justify-content-end mb-3">
          <Link to="/default-dose" className="btn btn-link">
            <Button variant="primary">Back</Button>
          </Link>
        </div>

        <div className="card">
          <div className="card-body">

            <form onSubmit={handleSubmit}>
              {/* Default Dose */}
              <div className="mb-3">
                <label className="form-label">
                  Default Dose <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="4"
                  value={text}
                  style={{ padding: "0.375rem 0.75rem", paddingTop: "0.6rem" }}
                  onChange={(e) => handleFieldChange("text", e.target.value)}
                  placeholder="Enter Default Dose"
                />
                {errors.text && (
                  <small className="text-danger">{errors.text}</small>
                )}
              </div>

              {/* Status */}
              <div className="mb-3">
                <label className="form-label">
                  Status <span className="text-danger">*</span>
                </label>

                <Select
                  options={statusOptions}
                  value={statusOptions.find((opt) => opt.value === status)}
                  onChange={(selectedOption) =>
                    setStatus(selectedOption ? selectedOption.value : "")
                  }
                  placeholder="Select Status"
                  isClearable
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: "50px",
                      height: "50px",
                      borderColor: errors.status
                        ? "#dc3545"
                        : provided.borderColor,
                      boxShadow: errors.status
                        ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                        : provided.boxShadow,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      lineHeight: "50px",
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      padding: "4px",
                    }),
                    indicatorSeparator: () => ({
                      display: "none",
                    }),
                  }}
                />

                {errors.status && (
                  <small className="text-danger">{errors.status}</small>
                )}
              </div>


              {/* Submit */}
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">
                      {isEditMode ? "Updating..." : "Submitting..."}
                    </span>
                  </>
                ) : (
                  <>{isEditMode ? "Update Default Dose" : "Add Default Dose"}</>
                )}
              </button>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDefaultDose;
